/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agents_EyebrowInputs */

const en_home_agents_eyebrow = /** @type {(inputs: Home_Agents_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For AI agents`)
};

/**
* | output |
* | --- |
* | "For AI agents" |
*
* @param {Home_Agents_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_agents_eyebrow = /** @type {((inputs?: Home_Agents_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agents_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_agents_eyebrow(inputs)
});
export { home_agents_eyebrow as "home.agents.eyebrow" }